import { PlanTab } from '../../../../../components/verification/SubscriptionStep';
import { SubscriptionTerm } from '../../../../../services/exports/Constants';

export default {
  sections: {
    term: {
      description: 'Faturado mensalmente. Anual é um termo de compromisso, não uma frequência de faturação.',
      options: {
        [SubscriptionTerm.Monthly]: 'Termo mensal',
        [SubscriptionTerm.Annual]: 'Termo anual',
      },
    },
    plans: {
      tabs: {
        [PlanTab.actual]: {
          name: 'Modelo de preço',
          title: 'Escala de preços baseada no sucesso',
        },
        [PlanTab.legacy]: {
          name: 'Legado',
          title: 'Planos',
        },
      },
    },
    add_ons: {
      title: 'Torne-se Pro com os nossos extras para o Plano Essencial',
      description: 'Atraia novos clientes e incentive visitas repetidas com estas soluções de software.',
    },
  },
  labels: {
    recommended: 'Recomendado',
    basket: 'Cesto: <strong>{{amount}}</strong> por mês',
  },
  buttons: {
    review_and_subscribe: 'Rever e subscrever',
    cancel: 'Cancelar',
    basket: 'Voltar ao cesto',
    subscribe: 'Subscrever',
    update_subscription: 'Atualizar subscrição',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
    failed_to_save_contract: 'Falha ao guardar o contrato de serviço',
    failed_to_create_subscription: 'Falha ao criar a subscrição',
    subscription_created: 'Subscrição criada com sucesso',
    subscription_updated: 'Subscrição atualizada com sucesso',
  },
};
